import { useState, useEffect } from 'react';
import { TopToolbar, useRecordContext, AutocompleteInput, ExportButton, Button, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField } from 'react-admin';
import IconAdd from '@mui/icons-material/Add';

import * as React from 'react';
import Box from '@mui/material/Box';
//import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import {default as MUITextField} from '@mui/material/TextField';
import {default as MUIButton} from '@mui/material/Button';
import {default as MUIMenuItem} from '@mui/material/MenuItem';
import {default as MUISelect} from '@mui/material/Select';
import {default as FormControl} from '@mui/material/FormControl';

import {fetcherGetSync, fetcherSync} from "../utils/fetcher";
import config from "../config";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const buttonContainer = {
    textAlign: "center",
    marginTop: "20px"
}

const buttonStyle = {
    marginLeft: "10px",
    marginRight: "10px",
}

const inputStyle = {
    width: "100%",
    margin: "auto",
    textAlign: "center",
    marginBottom: 10
}

const textStyle = {
    width: "100%",
    margin: "auto",
    textAlign: "center"
}


export default function OrderSupplementModalCreate(props) {
    const record = useRecordContext();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [productTitle, setProductTitle] = React.useState("");
    const [productPrice, setProductPrice] = React.useState(0);
    const [count, setCount] = React.useState(0);

    const createTempProduct = (orderId, productTitle, productPrice, count) => {
        var resProduct = fetcherSync(config.API_HOST+"/products", "POST", {
            productFamilyId: 7,
            product: productTitle,
            details: "SUPPLÉMENT",
            price: productPrice,
            transportByCarMode: "price",
            transportByCarValue: 100,
            minDelay: 2,
            deleted: 1 // PRODUIT TEMPORAIRE, CRÉEE SEULEMENT POUR CE SUPPLÉMENT
        });
        var resOrderProduct = fetcherSync(config.API_HOST+"/orderProducts", "POST", {
            orderId: orderId,
            productId: resProduct.id,
            count: count
        });
        setTimeout(() => window.location.reload(), 1000);
    }

    return (
        <div>
            <Button
                onClick={() => { handleOpen() }}
                label="Ajouter un supplément"
                style={{width: "100%", textAlign: "center"}}
            >
                <IconAdd/>
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={textStyle}>
                        Ajouter un supplément à la commande
                    </Typography>

                    <Typography id="modal-modal-description" sx={{ mt: 2 }} style={textStyle}>
                        Nom du supplément :
                    </Typography>
                    <MUITextField value={productTitle} onChange={(e) => setProductTitle(e.target.value)} label="Nom" style={inputStyle} />

                    <Typography id="modal-modal-description" sx={{ mt: 2 }} style={textStyle}>
                        Prix (TTC) :
                    </Typography>
                    <MUITextField value={productPrice} onChange={(e) => setProductPrice(e.target.value)} label="Prix TTC" style={inputStyle} />

                    <Typography id="modal-modal-description" sx={{ mt: 2 }} style={textStyle}>
                        Quantité :
                    </Typography>
                    <MUITextField value={count} onChange={(e) => setCount(e.target.value)} label="Quantité" style={inputStyle} />

                    <div style={buttonContainer}>
                        <MUIButton onClick={handleClose} style={buttonStyle} variant="outlined" color="error">
                            Quitter
                        </MUIButton>
                        <MUIButton onClick={() => createTempProduct(record.id, productTitle, productPrice, count)} style={buttonStyle} variant="contained" color="success">
                            Ajouter
                        </MUIButton>
                    </div>

                </Box>
            </Modal>
        </div>
    );
}